module.exports = __webpack_public_path__ + "img/reference12.32ee917a.jpg";